import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import type { DocumentFindInterface } from '@zaoblako/shared/modules/document/dtos/document/document-find.dto';
import { ChartModeEnum } from '@zaoblako/shared/modules/dashboard/enums/chart-mode.enum';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { DocumentRegistryService } from '@zaoblako/web/core/services/document/document-registry.service';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { TypeFormEnum } from '@zaoblako/web/shared/components/form-sidebar/enums/type.form.enum';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { SumPipe } from '@zaoblako/web/shared/pipes/sum.pipe';

import * as moment from 'moment-timezone';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'crm-document-split-widget',
  templateUrl: './document-split-widget.component.html',
  imports: [
    CommonModule,
    CardModule,
    ButtonShowAndHideComponent,
    SumPipe,
    SpinnerComponent,
    TableComponent,
    ButtonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentSplitWidgetComponent implements OnInit, OnDestroy {
  @Input() public readonly index: number;

  public documentsInfo: {
    documents: DocumentFindInterface[];
    loading: boolean;
    documentsShow: boolean;
  } = {
    documents: [],
    loading: true,
    documentsShow: true
  };

  public columns: CrmTableColumn[] = [{ label: '№' }, { label: 'Сумма' }];

  private formSubscription$: Subscription = new Subscription();

  public constructor(
    private readonly documentRegistryService: DocumentRegistryService,
    private readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    if (this.documentsInfo.documentsShow) {
      this.loadDocuments();
    }
  }

  public ngOnDestroy(): void {
    this.formSubscription$?.unsubscribe();
  }

  public loadDocuments() {
    this.documentsInfo = {
      ...this.documentsInfo,
      loading: true
    };

    this.documentRegistryService
      .getRelatedDocuments(this.formStoreService.getState.forms[this.index]?.entityId as any)
      .subscribe({
        next: (documents) => {
          this.documentsInfo = {
            ...this.documentsInfo,
            documents,
            loading: false
          };
          this.cdRef.markForCheck();
        }
      });
  }

  public toDocument(document: any): DocumentFindInterface {
    return document as DocumentFindInterface;
  }

  public showButtonChange(isShow: boolean) {
    if (isShow) {
      this.loadDocuments();
    }
    this.documentsInfo = {
      ...this.documentsInfo,
      documentsShow: !this.documentsInfo.documentsShow
    };
  }

  public editDocument(code: string) {
    const result = this.formStoreService.editForm(TypeFormEnum.DOCUMENT, code as any, {
      headerText: `Редактирование документа №${code}`,
      isShowShare: true
    });

    this.formSubscription$.add(result.onSave.subscribe(() => this.loadDocuments()));
    this.formSubscription$.add(result.onDelete.subscribe(() => this.loadDocuments()));
  }

  public directToDocumentsList() {
    const queryParams = {
      from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      periodChart: ChartModeEnum.WEEK,
      isStartSearch: true
    };
    const url = String(this.router.createUrlTree(['/document/list'], { queryParams }));
    window.open(url, '_blank');
  }
}
